import React from "react";
import {IProtocolStepKind} from "../types/protocol";
import {
    IconDeviceWatchHeart,
    IconHeartbeat,
    IconNotes,
    IconQuestionMark,
    IconWaveSine,
    IconWheel,
    IconZzz,
    IconFolder,
    IconInfoCircle,
    IconBandage,
    IconPlayerPlay,
    IconPlayerStop,
    IconEye,
    IconPlugConnected,
    IconListCheck
} from "@tabler/icons-react";

interface StepIconProps {
    kind: IProtocolStepKind;
    size?: string;
}

export const StepIcon: React.FC<StepIconProps> = ({kind, size = "1rem"}) => {
    switch (kind) {
        case IProtocolStepKind.REST_EVENT:
            return <IconZzz size={size}/>
        case IProtocolStepKind.MEG_SCAN:
        case IProtocolStepKind.EEG_SCAN:
            return <IconWheel size={size}/>
        case IProtocolStepKind.ECG_SCAN:
            return <IconHeartbeat size={size}/>
        case IProtocolStepKind.STIM_EVENT:
            return <IconWaveSine size={size}/>
        case IProtocolStepKind.MEASURE_BP:
            return <IconDeviceWatchHeart size={size}/>
        case IProtocolStepKind.MEASURE_HR:
            return <IconHeartbeat size={size}/>
        case IProtocolStepKind.MEASURE_PLR:
            return <IconEye size={size}/>
        case IProtocolStepKind.NOTE:
            return <IconNotes size={size}/>
        case IProtocolStepKind.Q_AND_A:
            return <IconQuestionMark size={size}/>
        case IProtocolStepKind.QUESTIONNAIRE:
            return <IconListCheck size={size}/>
        case IProtocolStepKind.START_DATA_COLLECTION:
            return <IconPlayerPlay size={size}/>
        case IProtocolStepKind.STOP_DATA_COLLECTION:
            return <IconPlayerStop size={size}/>
        case IProtocolStepKind.GROUP:
            return <IconFolder size={size}/>
        case IProtocolStepKind.INSTRUCTIONS:
            return <IconInfoCircle size={size}/>
        case IProtocolStepKind.VAS_PAIN_SCORE:
            return <IconBandage size={size}/>
        case IProtocolStepKind.NRS_PAIN_SCORE:
            return <IconBandage size={size}/>
        case IProtocolStepKind.PP_RELIEF:
            return <IconBandage size={size}/>
        case IProtocolStepKind.PORT_CONFIG:
            return <IconPlugConnected size={size}/>
        default:
            // TypeScript exhaustive check: this function ensures all enum cases are handled
            // If you add a new IProtocolStepKind, you'll get a compile error here
            return assertNever(kind);
    }
}

// Helper function for exhaustive type checking
function assertNever(value: never): never {
    throw new Error(`Unhandled step kind: ${value}`);
}
